import React, { useState,useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Button } from 'reactstrap';

export default function Individual() {
    const [page, setPage] = useState('1')
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate()
    const [lawyers, setLawyers] = useState([])
    const [police, setPolice] = useState([])
    const [magistrates, setMagistrates] = useState([])
    const [auctioneers, setAuctioneers] = useState([])


        const exportToPdf1 = () => {
            const doc = new jsPDF();
        
            // Add a title to the PDF
            doc.text("PoliceOfficer_Report", 20, 10);
        
            // Extract table headers and rows from the DOM
            const table = document.getElementById("dataTable1");
            const headers = Array.from(
              table.querySelectorAll("thead tr th")
            ).map((header) => header.textContent);
        
            const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) =>
              Array.from(row.querySelectorAll("td")).map((cell) => cell.textContent)
            );
        
            // Generate the PDF table
            doc.autoTable({
              head: [headers],
              body: rows,
              startY: 20,
            });
        
            // Save the PDF
            doc.save("police_report.pdf");
          };

          const exportToPdf2 = () => {
            const doc = new jsPDF();
        
            // Add a title to the PDF
            doc.text("Lawyers_Report", 20, 10);
        
            // Extract table headers and rows from the DOM
            const table = document.getElementById("dataTable2");
            const headers = Array.from(
              table.querySelectorAll("thead tr th")
            ).map((header) => header.textContent);
        
            const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) =>
              Array.from(row.querySelectorAll("td")).map((cell) => cell.textContent)
            );
        
            // Generate the PDF table
            doc.autoTable({
              head: [headers],
              body: rows,
              startY: 20,
            });
        
            // Save the PDF
            doc.save("lawyers_report.pdf");
          };

          const exportToPdf3 = () => {
            const doc = new jsPDF();
        
            // Add a title to the PDF
            doc.text("Magistrates_Report", 20, 10);
        
            // Extract table headers and rows from the DOM
            const table = document.getElementById("dataTable3");
            const headers = Array.from(
              table.querySelectorAll("thead tr th")
            ).map((header) => header.textContent);
        
            const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) =>
              Array.from(row.querySelectorAll("td")).map((cell) => cell.textContent)
            );
        
            // Generate the PDF table
            doc.autoTable({
              head: [headers],
              body: rows,
              startY: 20,
            });
        
            // Save the PDF
            doc.save("magistrate_report.pdf");
          };

          const exportToPdf4 = () => {
            const doc = new jsPDF();
        
            // Add a title to the PDF
            doc.text("Auctioneer_Report", 20, 10);
        
            // Extract table headers and rows from the DOM
            const table = document.getElementById("dataTable4");
            const headers = Array.from(
              table.querySelectorAll("thead tr th")
            ).map((header) => header.textContent);
        
            const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) =>
              Array.from(row.querySelectorAll("td")).map((cell) => cell.textContent)
            );
        
            // Generate the PDF table
            doc.autoTable({
              head: [headers],
              body: rows,
              startY: 20,
            });
        
            // Save the PDF
            doc.save("auctioneer_report.pdf");
          };



    const logout=()=>{
        localStorage.removeItem('email');
        navigate('/login')
      }

      const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toNew =()=>{
        navigate('/new-claim')
    }
    const toReport =()=>{
        navigate('/report')
    }
    const toUsers =()=>{
        navigate('/users')
    }

    useEffect(()=>{
        const getLawywer =async()=>{
            const res = await fetch('https://panel.yunshuglobal.com:3063/api/getLawyers');
            const data = await res.json();
            setLawyers(data)
        }
        const getPolice =async()=>{
            const res = await fetch('https://panel.yunshuglobal.com:3063/api/getPolice');
            const data = await res.json();
            setPolice(data)
        }
        const getMagistrates =async()=>{
            const res = await fetch('https://panel.yunshuglobal.com:3063/api/getMagistrates');
            const data = await res.json();
            setMagistrates(data)
        }

        const getAuctioneers =async()=>{
            const res = await fetch('https://panel.yunshuglobal.com:3063/api/getAuctioneers');
            const data = await res.json();
            setAuctioneers(data)
        }


        getLawywer()
        getPolice()
        getMagistrates()
        getAuctioneers()

    },[])

    const page1=()=>{
        setPage('1')
    }
    const page2=()=>{
        setPage('2')
    }
    const page3=()=>{
        setPage('3')
    }
    const page4=()=>{
        setPage('4')
    }



  return (
    <div>
                <div className="homeTop2">
            <div className="menuBar">
                <h4 className='menuTitle'>Motor Claims Database</h4>
                    <div className="menuList">
              
                        <p className='menu'>All Claims</p>
          
                        <p className='menu'>Individual Reports</p>
                        <p className='menu' onClick={toReport}>Reports</p>
                        <p className='menu' onClick={logout}>Sign Out</p>
                        
                    </div>
                
                
                
                
                <div className="phoneMenu">
                    <header className='header'>
                        <div className="menu-icon" onClick={toggleMenu}>
                        <span className="bar"></span>
                        <span className="bar"></span>
                        <span className="bar"></span>
                        </div>

                        <nav className={`nav-menu ${isOpen ? 'open' : ''}`}>
                        <ul>
                            <li ><a href="/">My Claims</a></li>
                            <li onClick={toNew}><a>New Claim</a></li>
                            <li  onClick={toReport}><a>Reports</a></li>
                            <li onClick={logout}><a>Sign Out</a></li>
                        </ul>
                        </nav>
                    </header>
                </div>
            </div>
           

        </div>

        <div className="homeContainer">
            <h4>Individual reports</h4>
            <hr />
            <div className="topnav">
             <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Select" onChange={(e)=>{setPage(e.target.value)}}>
                <Form.Select  className='inputSearch'   > 
                <option selected disabled>Select</option>
                <option value='1'>Police Officers</option>
                <option value='2'>Lawyers</option>
                <option value='3'>Magistrates</option>
                <option value='4'>Auctioneers</option>

                </Form.Select>
            
            </FloatingLabel>
            
               
                
            </div>

            {page == '1' &&
            <div>
            <br />
                <h5>All Reporting Police Officer</h5>
                <Button color='success' onClick={exportToPdf1} style={{marginBottom:'1%'}}>Export as pdf</Button>
                <div className="table-responsive">
                <Table striped bordered hover id="dataTable1" border="1">

                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Police Office </th>
                            <th scope="col">Police Phone </th>
                            <th scope="col">No.Of Cases</th>
                            <th scope="col">Amount awarded(Kes)</th>

                         
                        </tr>
                    </thead>
                    <tbody>
                        {police.map((val,index)=>{
                            const policyDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.OccurenceDate)
                           
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{val.Police}</td>
                                    <td>{val.PolicePhone}</td>
                                    <td>{val.cases}</td>
                               
                                    <td>{val.awards}</td>
                                  
                                   
                                    

                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>


            </div>
            
            
            
            }

            {page == '2' &&
            <div>
            <br />
                <h5>All lawyers</h5>
                <Button color='success' onClick={exportToPdf2} style={{marginBottom:'1%'}}>Export as pdf</Button>
                <div className="table-responsive">
                <Table striped bordered hover id="dataTable2" border="1">

                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Lawyer</th>
                            <th scope="col">Law firm</th>
                            <th scope="col">No.Of Cases</th>
                            <th scope="col">Amount awarded(Kes)</th>

                         
                        </tr>
                    </thead>
                    <tbody>
                        {lawyers.map((val,index)=>{
                            const policyDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.OccurenceDate)
                           
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{val.Lawyer}</td>
                                    <td><button  className='tableButton' value={val.Id} >{val.lawFirm}</button></td>
                                    <td>{val.cases}</td>
                               
                                    <td>{val.awards}</td>
                                  
                                   
                                    

                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>


            </div>
            
            
            
            }

            {page == '3' &&
            <div>
            <br />
                <h5>All Magistrates</h5>
                <Button color='success' onClick={exportToPdf3} style={{marginBottom:'1%'}}>Export as pdf</Button>
                <div className="table-responsive">
                <Table striped bordered hover id="dataTable3" border="1">

                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Magistrate</th>
                            <th scope="col">No.Of Cases</th>
                            <th scope="col">Amount awarded(Kes)</th>

                         
                        </tr>
                    </thead>
                    <tbody>
                        {magistrates.map((val,index)=>{
                            const policyDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.OccurenceDate)
                           
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{val.Magistrate}</td>
                                    <td>{val.cases}</td>
                               
                                    <td>{val.awards}</td>
                                  
                                   
                                    

                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>


            </div>
            
            
            
            }

            {page == '4' &&
            <div>
            <br />
                <h5>All Auctioneers</h5>
                <Button color='success' onClick={exportToPdf4} style={{marginBottom:'1%'}}>Export as pdf</Button>
                <div className="table-responsive">
                <Table striped bordered hover id="dataTable4" border="1">

                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Auctioneer</th>
                            <th scope="col">No.Of Cases</th>
                            <th scope="col">Amount awarded(Kes)</th>

                         
                        </tr>
                    </thead>
                    <tbody>
                        {auctioneers.map((val,index)=>{
                            const policyDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.OccurenceDate)
                           
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{val.auctioneer}</td>
                                    <td>{val.cases}</td>
                               
                                    <td>{val.awards}</td>
                                  
                                   
                                    

                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>


            </div>
            
            
            
            }



        </div>
    </div>
  )
}
